import { render, staticRenderFns } from "./InstitutionalFramework.vue?vue&type=template&id=7ed2c648&"
import script from "./InstitutionalFramework.vue?vue&type=script&lang=js&"
export * from "./InstitutionalFramework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports